import styled from 'styled-components';

// type Props = {
//   children: React.ReactNode,
//   isHidden: Boolean, // useful shortcut for turning on and off to test wrapping parent border styles
// };

// see style declarations in Figma: https://www.figma.com/file/FylbBZlEj7xh0MRTnVez9U/All-projects?node-id=14%3A254
const StyledMeta = styled.div`
  background: #eff0f0;
  border-bottom: 1px solid #d6d6d6;
  padding: 15px;
  width: 100%;
`;

export const StyledMetaInput = (Component /*: React.ReactNode */) => styled(Component)`
  && {
    input {
      background: #fff;
      border: 1px solid #c3c3c5;
      border-radius: 4px;

      ::placeholder {
        color: ${({ theme }) => theme.colors.gray80};
      }
    }
  }
`;

/**
 * built with partial application in the chance that we want to feature flag new styling and add
 * a differently styled wrapper to replicate the legacy table styles
 */
export const createTableMeta =
  (Wrapper) =>
  ({ children, isHidden = false, ...props }) => {
    if (!children || isHidden) {
      return null;
    }

    return (
      <Wrapper data-test="table-meta" id="table-meta" {...props}>
        {children}
      </Wrapper>
    );
  };

export const TableMeta = createTableMeta(StyledMeta);
